import React, { useEffect, useState } from 'react'
import moment from 'moment'
import API from '../../../services/API'
import InfoCard from '../../../components/Cards/InfoCard'
import CustomDataGrid from '../../../components/DataGrid/CustomDataGrid'
import { useNavigate } from 'react-router-dom'

const ExistingJourneys = ({ patientID, openInNewTab }) => {
  const [currentJourneys, setCurrentJourneys] = useState([])
  const [fetchError, setFetchError] = useState(false)
  const [loading, setLoading] = useState(false)
  const [length, setLength] = useState(0)
  const [skip, setSkip] = useState()

  const navigate = useNavigate()

  const loadCurrentJourneys = ({ loadAll }) => {
    setLoading(true)
    API.get(
      '/pts/patient-journeys/' +
        patientID +
        `?showAll=${loadAll ? 'true' : 'false'}`
    )
      .then((res) => {
        if (res.status === 200) {
          setCurrentJourneys(res.data)
        } else {
          setFetchError(true)
        }
      })
      .catch((e) => {
        console.error(e)
        setFetchError(true)
      })
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    if (!patientID) {
      setCurrentJourneys([])
      setLoading(null)
    } else {
      API.get('/pts/patient-journeys/' + patientID)
        .then((res) => {
          if (res.status === 200) {
            setCurrentJourneys(res.data)
          }
        })
        .catch((e) => {
          console.error(e.message)
          setFetchError(true)
        })
        .finally(() => setLoading(false))
    }
  }, [patientID])

  return (
    <InfoCard title="Current Journeys">
      <CustomDataGrid
        rows={currentJourneys}
        columns={[
          {
            field: 'status',
            headerName: 'Status',
            flex: 0.4,
            minWidth: 80,
          },
          {
            field: 'pickup',
            renderCell: ({ row }) =>
              `${
                row?.pickup?.when?.patientReadyFrom
                  ? moment(row?.pickup?.when?.patientReadyFrom)
                      .format('DD/MM/YYYY HH:mm')
                      .toString()
                  : ''
              }` +
              `${
                row?.pickup?.when?.patientReadyFrom && row?.pickup?.name
                  ? ' - '
                  : ''
              }` +
              `${row?.pickup?.name ? row.pickup.name : ''}`,
            flex: 1,
            minWidth: 100,
            headerName: 'Pickup',
          },
          {
            field: 'dropoff',
            renderCell: ({ row }) =>
              `${
                row?.dropoff?.when?.targetArrivalTime
                  ? moment(row?.dropoff?.when?.targetArrivalTime)
                      .format('DD/MM/YYYY HH:mm')
                      .toString()
                  : ''
              }` +
              `${
                row?.dropoff?.when?.targetArrivalTime && row?.dropoff?.name
                  ? ' - '
                  : ''
              }` +
              `${row?.dropoff?.name ? row.dropoff.name : ''}`,
            flex: 1,
            minWidth: 100,
            headerName: 'Dropoff',
          },
          {
            field: 'journeyType',
            headerName: 'Type',
            flex: 0.5,
            minWidth: 100,
          },
        ]}
        disableRowSelectionOnClick
        onRowClick={({ row }) =>
          openInNewTab
            ? window.open('/pts/bookings/' + row.booking)
            : navigate('/pts/bookings/' + row.booking)
        }
        slots={{
          toolbar: () => null,
          footer: () => null,
        }}
        getRowId={(row) => row._id}
      />
    </InfoCard>
  )
}

export default ExistingJourneys
